
// import { useEffect, useState, useCallback } from "react";
// import { toast } from "react-toastify";
// import { fetchProjects } from "../../apis/projectApi";

// export const useProjects = ({ page, pageSize, search, status, vendor }) => {
//   const [projects, setProjects] = useState([]);
//   const [totals, setTotals] = useState({
//     totalProjects: 0,
//     activeProjects: 0,
//     totalArea: 0,
//     activeVendors: 0,
//   });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   const loadProjects = useCallback(async (silent = false) => {
//     setLoading(true);
//     setError(null);

//     let toastId = null;
//     if (!silent) {
//       toastId = toast.loading("Loading projects...");
//     }

//     try {
//       const params = {
//         page,
//         page_size: pageSize,
//         search: search || undefined,
//         status: status !== "All Status" ? status.toLowerCase() : undefined,
//         vendor: vendor !== "All Vendors" ? vendor : undefined,
//       };

//       const data = await fetchProjects(params);

//       if (data?.data) {
//         setProjects(data.data);

//         // Calculate totals
//         const activeCount = data.data.filter((p) => p.status?.toLowerCase() === "active").length;
//         const vendors = new Set(data.data.map((p) => p.organization_name));
        
//         setTotals({
//           totalProjects: data.data.length,
//           activeProjects: activeCount,
//           totalArea: 0, // still 0 - update when area field is available
//           activeVendors: vendors.size,
//         });

//         if (toastId) {
//           toast.update(toastId, {
//             render: "Projects loaded",
//             type: "success",
//             isLoading: false,
//             autoClose: 1500, // very short for list views
//           });
//         }
//       }
//     } catch (err) {
//       const errorMessage =
//         err.response?.data?.data ||
//         err.data ||
//         "Failed to fetch projects. Please try again.";

//       if (toastId) {
//         toast.update(toastId, {
//           render: errorMessage,
//           type: "error",
//           isLoading: false,
//         });
//       } else {
//         toast.error(errorMessage);
//       }

//       setError(errorMessage);
//     } finally {
//       setLoading(false);
//     }
//   }, [page, pageSize, search, status, vendor]);

//   useEffect(() => {
//     loadProjects(true); // silent on initial mount & filter changes
//   }, [loadProjects]);

//   // Optional: expose a public refetch method that shows feedback
//   const refetch = () => loadProjects(false);

//   return { projects, totals, loading, error, refetch };
// };

import { useEffect, useState, useCallback } from "react";
import { toast } from "react-toastify";
import { fetchProjects } from "../../apis/projectApi";

export const useProjects = ({ page, pageSize, search, status, vendor }) => {
  const [projects, setProjects] = useState([]);
  const [totals, setTotals] = useState({
    totalProjects: 0,
    activeProjects: 0,
    totalArea: 0,
    activeVendors: 0,
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const extractError = (err) => {
      // err is the plain object thrown by projectApi's handleApiError:
      // { status, message, data }
      return {
        title: err.message || "Update Failed",
        issue:
          err.data?.data ||   // "images: The submitted data was not a file..."
          err.message ||
          "Failed to load project. Please try again.",
      };
    };

  const loadProjects = useCallback(
    async (silent = false) => {
      setLoading(true);
      setError(null);

      let toastId = null;

      if (!silent) {
        toastId = toast.loading("Loading projects...");
      }
      try {
            const params = {
              page,
              page_size: pageSize,
              search: search || undefined,
              status: status !== "All Status" ? status.toLowerCase() : undefined,
              vendor: vendor !== "All Vendors" ? vendor : undefined,
            };

            const data = await fetchProjects(params);

            if (data?.data) {
              setProjects(data.data);

              // Calculate totals
              const activeCount = data.data.filter((p) => p.status?.toLowerCase() === "active").length;
              const vendors = new Set(data.data.map((p) => p.organization_name));
              
              setTotals({
                totalProjects: data.data.length,
                activeProjects: activeCount,
                totalArea: 0, // still 0 - update when area field is available
                activeVendors: vendors.size,
              });

              if (toastId) {
                toast.update(toastId, {
                  render: "Projects loaded",
                  type: "success",
                  isLoading: false,
                  autoClose: 1500, // very short for list views
                });
              }
            }
    } catch (err) {
        const { title, issue } = extractError(err);

        if (toastId) {
          toast.update(toastId, {
            render: (
              <div>
                <strong>{title}</strong>
                <div>{issue}</div>
              </div>
            ),
            type: "error",
            isLoading: false,
            autoClose: 5000,
          });
        } else {
          toast.error(
            <div>
              <strong>{title}</strong>
              <div>{issue}</div>
            </div>
          );
        }

        setError({ title, issue });
      } finally {
        setLoading(false);
      }
    },
    [page, pageSize, search, status, vendor]
  );

  useEffect(() => {
    loadProjects(true); // silent on mount & filter change
  }, [loadProjects]);

  const refetch = () => loadProjects(false);

  return { projects, totals, loading, error, refetch };
};